export default (store) => {
  const ability = store.getters['user/ability']

  const mapAbilities = (abilities) => {
    return abilities.map(({ name: action, forbidden: inverted }) => ({ action, inverted }))
  }

  ability.update(mapAbilities(store.state.user.authorized.abilities || []))

  return store.subscribe((mutation) => {
    switch (mutation.type) {
      case 'user/SET_AUTHORIZED':
        ability.update(mapAbilities(store.state.user.authorized.abilities || []))
        break
    }
  })
}
